import { ChangeEvent } from 'react'

import { UseFormPayload } from '@domain-group/react-hooks'

import {
  Box, DashboardModule, Form,
} from '@domain-group/suit-theme'

interface HandleTitleChangeParams {
  e: ChangeEvent<HTMLInputElement>,
  setEntityState: UseFormPayload['setEntityState'],
}

const handleTitleChange = (params: HandleTitleChangeParams) => {
  const { e, setEntityState } = params
  const { value } = e.target
  setEntityState({ street_name: value, title: value })
}

interface AgencyMarketingProps {
  campaignFormPayload: UseFormPayload,
}

const AgencyMarketing = (props: AgencyMarketingProps) => {
  const { campaignFormPayload } = props

  const {
    entityState, handlers, setEntityState,
  } = campaignFormPayload

  const {
    post_code, state_name, suburb_name, title,
  } = entityState

  return (
    <DashboardModule title="Details">
      <Box flexDirection="column" padding="large">
        <Form.Field label="Campaign Title">
          <input type="text" name="title" value={title} onChange={e => handleTitleChange({ e, setEntityState })} />
        </Form.Field>

        <Form.Field label="Campaign Label" marginTop="large">
          <input type="text" name="suburb_name" value={suburb_name} {...handlers} />
        </Form.Field>

        <Form.Field label="Agency State" marginTop="large">
          <input disabled type="text" name="state_name" value={state_name} {...handlers} />
        </Form.Field>

        <Form.Field label="Agency Postcode" marginTop="large">
          <input disabled type="text" name="post_code" value={post_code} {...handlers} />
        </Form.Field>

        <Form.Field label="Campaign Type" marginTop="large">
          <select disabled>
            <option>Agency Marketing</option>
          </select>
        </Form.Field>
      </Box>
    </DashboardModule>
  )
}

export default AgencyMarketing
